import { internal, template } from '../../../vendor/elix.js';

function ButtonSmallMixin(Base) {

  return class ButtonSmall extends Base {

      get [internal.template]() {

        return template.concat(

          super[internal.template],

          template.html`
            <style>

              #inner {
                height: var(--tp-button-small-mixin-height);
                min-width: var(--tp-button-small-mixin-width);
                padding: var(--tp-button-small-mixin-padding-y) var(--tp-button-small-mixin-padding-x);
              }
              
            </style>
          `
        );
      }
    }
  }

export default ButtonSmallMixin;
